import React from 'react';

export type PremiumBadgeVariant = 'compact' | 'standard';

type PremiumBadgeProps = {
  variant?: PremiumBadgeVariant;
  /** Screen reader suffix, e.g. "Edit with AI, Bilt Premium feature" */
  featureLabel?: string;
  className?: string;
};

const variantClasses: Record<PremiumBadgeVariant, string> = {
  compact:
    'text-[9px] tracking-[0.14em] px-1.5 py-0.5',
  standard:
    'text-[10px] tracking-[0.16em] px-2 py-0.5',
};

/**
 * Canonical orange tag for Bilt:Spec Premium-gated features.
 * Use beside feature labels — not inside label text as "(Premium)".
 */
export const PremiumBadge: React.FC<PremiumBadgeProps> = ({
  variant = 'standard',
  featureLabel,
  className = '',
}) => {
  const aria = featureLabel ? `${featureLabel}, Bilt:Spec Premium feature` : 'Bilt:Spec Premium feature';

  return (
    <span
      className={`inline-flex shrink-0 items-center rounded border border-orange-500/40 bg-orange-500/15 font-semibold uppercase text-orange-300 ${variantClasses[variant]} ${className}`.trim()}
      aria-label={aria}
      title="Included with Bilt:Spec Premium"
    >
      Premium
    </span>
  );
};

export default PremiumBadge;
